import HPElitebook1040G9 from "../assets/hp/HPElitebook1040G9.jpeg";

const hpProducts = [
  {
    id: 1,
    name: "HP Elitebook 1040 G9",
    image: HPElitebook1040G9,
    specs: [
      "Core i5 12th gen vpro",
      "125U processor 10cores",
      "Full metal body Laptop",
      "16 GB DDR5 4800mhz RAM",
      "512 GB Nvme SSD",
      "Windows 11 pro lifetime",
      "Back-lit keyboard",
      "Bang & olufsen Audio",
      "HP wolf security",
      "14 wide anti glare 1920x1200 True FHD Display ",
    ],
    price: "₹62,999",
    whatsappText: "Hi, I am interested in HP Elitebook 1040 G9",
  },
];

export default hpProducts;